import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Leaderboard from './pages/Leaderboard';

const isPublicLeaderboard = window.location.pathname.replace(/\/+$/, '') === '/leaderboard';
const Root = isPublicLeaderboard ? Leaderboard : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

